import React from "react";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";
import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
} from "reactstrap";
import "../../styles/estilos.css";
import Page from "components/Page";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { listarColoresFetch, recuperarDatosFacturacionFetch } from "../../redux/actions/aCotizacion";
import "../../styles/table.scss";
import { withToastManager } from 'react-toast-notifications';
import { FetchPost } from "../../redux/actions/api";
import {urlEnviarFVinculacionCliente } from "../../constants/urls";
import { getTituloFv } from "../../helpers/helpersFV";
import { consultarUsuarioFV } from "../../redux/actions/aFormularioVinculacion";
import { empresa } from "../../constants";

class FormularioVinculacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      urlFormularioVinculacion:'',
      back:false,
      texto:'Cargando Formulario de Vinculación...',  
      yaTieneFormulario:false,
      modulo:'',
      idCarrito: new URLSearchParams(this.props.location.search).get('id')
    };
  }



  async componentDidMount() {   
    window.scrollTo(0, 0)
    // query params
    const queryParams = new URLSearchParams(this.props.location.search);
    var url = queryParams.get("url");
    var regresar = queryParams.get("back");
    var tieneFormulario = queryParams.get("haveForm");
    // ------------- Variables para el retorno desde la suscricpion de p2p--------------------
    const queryB64 = queryParams.get("query");
    if(queryB64 !== undefined && queryB64 !== null){
      const queryDecrypted = atob(queryB64);
      const queryAsObject = JSON.parse(queryDecrypted);
      console.log('query_es', queryB64, queryDecrypted, queryAsObject);

      // idCarrito
      this.setState({idCarrito:queryAsObject.idCarrito});

      // llamar servicio
      
      await this.props.consultarFv({content:'', id:queryAsObject.idCarrito});

      // verificar si tiene FV el usuario
      console.log('verificarFV', this.props.formularioVinculacion);
      const { transaccion, pasarPantallaFormulario, urlFormulario } = this.props.formularioVinculacion.usuarioFv;
      console.log('pasarPantallaFormulario', this.props.formularioVinculacion);
      if (transaccion) {
        if(pasarPantallaFormulario)
        {
          // sin FV
          url = urlFormulario;
        }
        else{
          let datosJSON = {
            empresa: empresa,
            plataforma: "WEB",
            idCarrito: queryAsObject.idCarrito,
          };
          // console.log('dataFacturacion1', this.props.dataFacturacion.datosFacturacion);
          await this.props.datosFacturacion(datosJSON);
          if (
            this.props.dataFacturacion.datosFacturacion &&
            this.props.dataFacturacion.datosFacturacion.carDescripcionRamo &&
            this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro
          ) {
            const descripcionRamo = this.props.dataFacturacion.datosFacturacion.carDescripcionRamo;
            const descripcionSeguro = this.props.dataFacturacion.datosFacturacion.carDescripcionSeguro;
            const titulo = getTituloFv(descripcionRamo, descripcionSeguro);
            // con FV
            tieneFormulario = titulo;
          }
        }
      }
    }
    // ------------- Terminan variables para el retorno desde la suscricpion de p2p--------------------
    if(url !== undefined && url !== null)
    {
      url=window.atob(url);
      this.setState({ urlFormVinculacion: url });
    }
    if(regresar !== undefined && regresar !== null)
    {      
      this.setState({ back: true });
    }
    if(tieneFormulario !== undefined && tieneFormulario !== null && tieneFormulario !== '')
    {      
      this.setState({ yaTieneFormulario: true, modulo:tieneFormulario });
    }
  }

  onClickRegresar = (e) => {
    const queryParams = new URLSearchParams(this.props.location.search);
    var urlbackreturn=queryParams.get('urlbackreturn');
    if(urlbackreturn !== undefined && urlbackreturn !== null)
    {
      //console.log('tttttttt')
      urlbackreturn=window.atob(urlbackreturn);
      this.props.history.replace(urlbackreturn);  
    }
    else{
      this.props.history.go(-1)  
    }
  }


  onClickEnviarFormulario = async (e)  => {   
    const { toastManager } = this.props;            
    this.setState({ isLoading: true , texto:'Enviando Formulario de Vinculación'});

    let resp = await FetchPost({
      url: urlEnviarFVinculacionCliente+this.state.idCarrito,
      param:''
    });
    const { transaccion } = resp;    
    this.setState({ isLoading: false });  
    if (transaccion) {   
      const content = (
        <div>   
          Se ha enviado el formulario de vinculación al correo electrónico del cliente.              
        </div>
      );       
      toastManager.add(content, {
        appearance: 'success',
      });  
      this.props.history.replace("/principal");  
    }
    else{  
      const content = (
        <div>   
          No se ha podido enviado el formulario de vinculación al correo electrónico del cliente. Por favor intente nuevamente.
        </div>
      );       
      toastManager.add(content, {
        appearance: 'warning',
      });  
    }

    

  
    
  }

  onClickFinalizar = (e) => {    
    this.props.history.replace("/principal");  
  }

  onClickPantallaFinal = (e) => {    
    const {  
      modulo,      
    } = this.state;
    
    this.props.history.push({
      pathname: "/final-cotizacionbroker",
      search: `?ramo=${modulo}`,
      });
  }

  render() {
    const {  
      isLoading,
      urlFormVinculacion,
      back,
      texto,
      yaTieneFormulario
    } = this.state;
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
            <LoadingScreen
              loading={isLoading || this.props.dataFacturacion.recuperarDatosFacturacionIsLoading || this.props.formularioVinculacion.usuarioFvLoading }
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text={texto}
            >
      


      <Page
        title='Formulario de Vinculación'
        breadcrumbs={[{ name: 'Formulario de Vinculación', active: true }]}
      >
        <Row>
          <Col lg={8} md={12} sm={12} xs={12}>
            <div className="container-step">
              <div className="wrapper-step">
                <div className="arrow-steps clearfix-step">
                  <div className="step">
                    {" "}
                    <span>1. Cotización</span>{" "}
                  </div>
                  <div className="step">
                    {" "}
                    <span>2. Resumen</span>{" "}
                  </div>
                  <div className="step">
                    {" "}
                    <span>3. Confirmación</span>{" "}
                  </div>
                  <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step current"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            lg={12}
            md={12}
            sm={12}
            xs={12}
            className="detalle-cotizacion-box"
          >
            <Card className="flex-row">
              <CardBody>


              {!yaTieneFormulario && 
              
              <Row>
              <Col lg={9} md={12} sm={12} xs={12}>
                {back && 
                  <Button
                  className={"button-white"}
                  onClick={this.onClickRegresar}
                >
                  <i class="fa fa-chevron-circle-left" aria-hidden="true" />{" "}
                  REGRESAR AL DETALLE
                </Button>
                  
                  }


                {!back && 
                  <Button
                  className="btn btn-purple"
                  onClick={this.onClickEnviarFormulario}
                >
                  <i class="fa fa-paper-plane-o" aria-hidden="true" />{" "}
                  ENVIAR FORMULARIO AL CLIENTE
                </Button>
                  
                  }  
              
              </Col>
              <Col lg={3} md={12} sm={12} xs={12}> 

              {!back && 
                  <div>
                <Button
                  className={"btn-secondary"}
                  onClick={this.onClickFinalizar}
                >
                  <i class="fa fa-check" aria-hidden="true" />{" "}
                  GESTIONAR MÁS TARDE
                </Button>
                <p className="leyenda-fv">Retomar desde Listado De Ventas, NO se enviará al cliente el link para llenar su formulario de vinculación</p>
                  </div>
                  
                  }

                  
              </Col>
                <Col lg={12} md={12} sm={12} xs={12}>     
                
                             

                  <div style={{ padding: "1em" }}>
                    <h2 style={{ color: "#001871"/*"#001872"*/, textAlign:"center" }}> COMPLETAR FORMULARIO DE VINCULACIÓN</h2>
                    <br></br>
                    <iframe className={"iframe-fvinculacion"} src={urlFormVinculacion}/>
                    <br></br>
                  </div>
                </Col>
              
              </Row>
              
              }

              {yaTieneFormulario &&
              
              <Row>              
                <Col lg={12} md={12} sm={12} xs={12}>
                    <div style={{ padding: "1em" }}>
                      <h2 style={{ color: "#001871", textAlign:"center" }}>FORMULARIO DE VINCULACIÓN VIGENTE</h2>
                      <br></br>                      
                       <div style={{  textAlign:"center" }}>
                          <h2>El cliente ya tiene un Formulario de Vinculación vigente, puede continuar con el siguiente paso dando click en el botón CONTINUAR.</h2>                          
                       </div>                      
                      <br></br>
                      <Row>
                      <Col lg={5} md={5} sm={5} xs={5}></Col>
                      <Col lg={2} md={2} sm={2} xs={2}>

                            <Button
                                className={"btn-purple"}
                                onClick={this.onClickPantallaFinal}
                              >
                                <i class="fa fa-check" aria-hidden="true" />{" "}
                                CONTINUAR
                              </Button>


                      </Col>
                      <Col lg={5} md={5} sm={5} xs={5}></Col>

                      </Row>
                      
                      
                    </div>
                  </Col>

                
              </Row>
              
              }

              

               
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row>
          <div style={{ paddingTop: "30em" }}></div>
        </Row>
      </Page>




            </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  dataUsuario: state.datosUsuarios.dataUsuario,
  formularioVinculacion: state.rFormularioVinculacion,
  //Obtener datos de un servicio comun
  dataFacturacion: state.dataFacturacion,
});

const mapDispatchToProps = (dispatch) => {
  return {
    listarColores: () => dispatch(listarColoresFetch()),
    consultarFv: (data) => dispatch(consultarUsuarioFV(data)),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
  };
};

export default withToastManager(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FormularioVinculacion)
));
